import { init as initSentry, Integrations } from '@sentry/browser'
import '@babel/polyfill'
import App from './App.vue'
import i18n from './i18n'
import Multiselect from 'vue-multiselect'
import store from '@/store'
import VeeValidate from 'vee-validate'
import VModal from 'vue-js-modal'
import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import { device } from '@/vendor/civ2-js-utils'
import { getUrlParams } from '@/utils/url'
import { router } from '@/router'
import { sync } from 'vuex-router-sync'
import IntlPolyfill from 'intl'
import 'intl/locale-data/jsonp/en'
import 'intl/locale-data/jsonp/de'
import 'intl/locale-data/jsonp/fr'
import 'intl/locale-data/jsonp/it'
import 'intl/locale-data/jsonp/es'
import 'intl/locale-data/jsonp/nl'

// Avoid naming collision with a potential custom `route` module
sync(store, router, { moduleName: 'router' })

Vue.config.productionTip = false
Vue.component('multiselect', Multiselect)
Vue.use(VeeValidate)
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })

Vue.use(VueProgressBar, {
  color: '#54C100',
  failedColor: '#F85359',
  thickness: '2px',
})

console.log(
  `%c CI Booking %c ${process.env.git.COMMITHASH} %c ${process.env.git.BRANCH} %c`,
  'background:#35495e; padding: 1px; border-radius: 3px 0 0 3px; color: #fff',
  'background:#54c100; padding: 1px; color: #fff',
  'background: #f5a623; padding: 1px; border-radius: 0 3px 3px 0; color: #fff',
  'background:transparent'
)

if (!window['Ixntl']) {
  window.Intl = IntlPolyfill
}

if (process.env.VUE_APP_SENTRY_DSN) {
  console.debug('activating sentry')
  initSentry({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: `${process.env.VUE_APP_ENVNAME}`,
    integrations: [new Integrations.Vue({ Vue })],
  })
}

Vue.filter('currency', function(value, currency, lang) {
  // Provide robust fallbacks to avoid runtime errors when currency/lang are not yet available
  try {
    const storeCurrency =
      (store.getters['application/currency'] && store.getters['application/currency'].code) ||
      (store.getters['campground/campground'] && store.getters['campground/campground'].currency) ||
      null

    const code = currency || storeCurrency || 'EUR'

    const storeLang =
      (store.getters['application/language'] && store.getters['application/language'].code) ||
      null
    const locale = lang || storeLang || (navigator && navigator.language) || 'de-DE'

    const amount = typeof value === 'number' ? value : (value ? Number(value) : 0)
    return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format(amount)
  } catch (e) {
    // As a last resort, format as a plain number with two decimals to prevent render crashes
    try {
      const locale = lang || (navigator && navigator.language) || 'de-DE'
      const amount = typeof value === 'number' ? value : (value ? Number(value) : 0)
      return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)
    } catch (e2) {
      return String(value == null ? '' : value)
    }
  }
})

// detect touch device
if (device.hasTouch()) {
  const root = document.getElementsByTagName('html')[0]
  if (root.classList.contains('no-touch')) {
    root.classList.remove('no-touch')
  }
}

export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  beforeMount: () => {
    const { lang, campground } = getUrlParams()
    store.dispatch('application/setLanguageSlug', lang)
    store.dispatch('application/setCampground', campground)

    // Seed draft booking id from URL as early as possible so Api.postData can forward it
    try {
      const q = router && router.currentRoute && router.currentRoute.query
      const existing = store.getters['booking/draftBookingId']
      if (q && q.draftbooking && !existing) {
        store.dispatch('booking/setDraftBookingId', q.draftbooking)
      }
    } catch (e) {
      // no-op
    }
  },
}).$mount('#app')
